import { CriteriaValue } from '../types';
import { LenderWaterfallConditions } from '@trnsact/types-lender-waterfall';
import { mapCriteriaToConditions } from './mapCriteriaToConditions';

export function getJSONCriteria(conditions: CriteriaValue[]) {
  const lenderWaterfallConditions = new LenderWaterfallConditions();
  const conditionsForSave = mapCriteriaToConditions(conditions);
  conditionsForSave.forEach(condition => lenderWaterfallConditions.addCondition(condition));

  return lenderWaterfallConditions.getConditions() as any;
}
